import { Components, Theme } from '@mui/material/styles';
import { FormHelperText } from './FormHelperText';

export const flowFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  defaultProps: {
    component: FormHelperText,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      display: 'block',
      width: '100%',
      margin: '4px 0',
      paddingLeft: '12px',
      paddingRight: '12px',
      color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os200 : theme.palette.onSurface.os600,
      transition: 'inherit',
      '&.Mui-disabled': {
        color: theme.palette.disabled.tertiary,
      },
      [theme.breakpoints.up('xs')]: {
        // custom font
        fontSize: '12px',
        fontWeight: '400',
        letterSpacing: '0',
        lineHeight: '16px',
      },
      ...(ownerState.truncate !== false
        ? {
            position: 'absolute',
            top: '100%',
            left: '0',
            right: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // match bottom padding from FormControl
            height: '16px',
          }
        : {
            position: 'static',
            minHeight: '16px',
            // remove fake space from TextField due to static position (height + top margin + bottom margin)
            marginBottom: `-${16 + 4 + 4}px`,
          }),
    }),
  },
};
